import React from 'react';

export default function RequiredLabel ({ children }: { children: React.ReactNode }) {
  return (
    <span>
      <span aria-hidden='true'>* </span>
      {children}
    </span>
  );
}
